import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {

  public static strip(value: string): string {
    if (value == undefined) {
      return '';
    }
    return value.replace(/<[^>]*>/g, '');
  }

  transform(value: string): string {
    return StripHtmlPipe.strip(value);
  }
}
